import { CustomerFeConfig } from 'src/app/modules/core/interfaces/environment.interface';

export const environment: CustomerFeConfig = {
	production: true
};
